/* istanbul ignore file */
import * as codec from 'purify-ts/Codec';
import { boolean as codecBoolean, number as codecNumber } from 'purify-ts/Codec';
import { parsers } from '@codegrade/utils';
import { NormalUser } from './NormalUser';
const AssignmentGraderParser = 
/* #__PURE__ */ /* #__PURE__ */ codec.intersect(
/* #__PURE__ */ parsers.object([
    ['weight', codecNumber],
    ['done', codecBoolean],
]), NormalUser);
export class AssignmentGrader extends NormalUser {
    static decode(input) {
        return AssignmentGraderParser.decode(input).map(res => new AssignmentGrader(res));
    }
    static unsafeDecode(input) {
        return AssignmentGrader.decode(input).unsafeCoerce();
    }
    static encode(data) {
        return AssignmentGraderParser.encode(data);
    }
    static schema() {
        return AssignmentGraderParser.schema();
    }
}
